import React from 'react'

import S from './NavButton.styled'
import { Menu } from '../../../Svg'
import { useHeaderContext } from '../../HeaderContext'
import { TabNavigation } from '../../../TabNavigation'

const NavButton = () => {
  const { isOpen, toggle, lightMode } = useHeaderContext()

  const toggleMenu = () => {
    toggle()
    document.body.classList.toggle('menu-open')
  }

  return (
    <S.NavButton menuIsOpen={isOpen} onClick={toggleMenu} lightMode={lightMode}>
      <TabNavigation className="menu-tab" onEnterPress={toggleMenu} />
      <Menu aria-hidden="true" />
      <span className="menu-title">Menu</span>
    </S.NavButton>
  )
}

export default NavButton
